import * as React from "react";

function ExitIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 15 16" {...props}>
      <path
        d="M11.133 12.333l1.534-1.066v2.4c0 1.266-1.067 2.333-2.334 2.333h-8C1.067 16 0 14.933 0 13.667V2.333C0 1.067 1.067 0 2.333 0h8c1.267 0 2.334 1.067 2.334 2.333v2.4l-1.534-1.066c-.133-.134-.333-.2-.466-.267V2.267c0-.2-.134-.334-.334-.334h-8c-.2 0-.333.134-.333.334V13.6c0 .2.133.333.333.333h8c.2 0 .334-.133.334-.333v-1.133c.133 0 .333-.067.466-.134zM14.2 7.467L10.4 4.8a.667.667 0 00-1.067.533v1.334H4.667c-.4 0-.667.266-.667.666v1.334c0 .4.267.666.667.666h4.666v1.334c0 .533.6.866 1.067.533l3.8-2.667c.4-.266.4-.8 0-1.066z"
        fill="currentcolor"
        fillRule="nonzero"
      />
    </svg>
  );
}

export default ExitIcon;
